<template>
  <div class="workresultlistdiv1">
    <div class="title_h1">作業報告書</div>
    <vab-query-form
      ref="queryForm"
      class="dpform DPR01G01"
      :model="queryForm"
      :rules="rules"
      size="mini"
      label-width="98px"
      @search="fetchData"
      @cancel="cancelSet"
    >
      <vab-row :gutter="24">
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-date-picker
            type="month"
            label="作業年月"
            value-format="yyyyMM"
            format="yyyy/MM"
            prop="workYm"
            class="width_140"
            validate="required"
            :clearable="false"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input label="建物" prop="blgsnmkj" maxlength="62" />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-input
            v-input.num_alp
            label="報告書No"
            prop="reportNo"
            maxlength="11"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <MitmdtlpNew
            :componentcd.sync="queryForm.itemDetailCdList"
            prop="itemDetailCdList"
            :multi-select="false"
            :span1="6"
            :span2="18"
            @clearOtherData="clearOtherData"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="workSpecRef"
            label="点検仕様"
            prop="workSpecCdList"
            :data-items="workSpecCdList"
            label-id="itmgkmnm"
            value-id="itmgkmcd"
            collapse-tags
            multiple
            :disabled="workSpecCdListDisabled"
            placeholder="選択されていません"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12" class="label_height">
          <el-form-item
            class="big_label_110 label_height"
            label="速報版提出期限日"
          >
            <el-row type="flex">
              <el-col :span="11">
                <vab-date-picker
                  type="date"
                  class="date_box no_margin"
                  label="速報版提出期限日"
                  placeholder=""
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  prop="preReportSubmintDeadlineFrom"
                  end-date-prop="preReportSubmintDeadlineTo"
                />
              </el-col>
              <el-col :span="2" class="line flex_center flex_center_align">
                〜
              </el-col>
              <el-col :span="11">
                <vab-date-picker
                  type="date"
                  class="date_box no_margin"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  prop="preReportSubmintDeadlineTo"
                  start-date-prop="preReportSubmintDeadlineFrom"
                  placeholder=""
                />
              </el-col>
            </el-row>
          </el-form-item>
        </vab-col>

        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="preReportStatus"
            label="速報版報告書状況"
            prop="preReportStatusList"
            filter="reportStatus"
            class="label_height"
            clearable
            multiple
            collapse-tags
            placeholder="選択されていません"
          />
        </vab-col>
        <vab-col :lg="8" :xl="8" :md="12" class="label_height">
          <el-form-item
            class="big_label_110 label_height"
            label="正式版提出期限日"
          >
            <el-row type="flex">
              <el-col :span="11">
                <vab-date-picker
                  type="date"
                  class="date_box no_margin"
                  placeholder=""
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  prop="officalReportSubmintDeadlineFrom"
                  end-date-prop="officalReportSubmintDeadlineTo"
                />
              </el-col>
              <el-col :span="2" class="line flex_center flex_center_align">
                〜
              </el-col>
              <el-col :span="11">
                <vab-date-picker
                  type="date"
                  class="date_box no_margin"
                  :label-show="false"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  prop="officalReportSubmintDeadlineTo"
                  start-date-prop="officalReportSubmintDeadlineFrom"
                  placeholder=""
                />
              </el-col>
            </el-row>
          </el-form-item>
        </vab-col>

        <vab-col :lg="8" :xl="8" :md="12">
          <vab-select
            ref="officalReportStatus"
            label="正式版報告書状況"
            prop="officalReportStatusList"
            filter="reportStatus"
            class="label_height"
            clearable
            multiple
            collapse-tags
            placeholder="選択されていません"
          />
        </vab-col>
        <vab-collapse title="詳細検索を表示">
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              ref="workFinishSelect"
              label="作業完了状況"
              prop="workFinishClassList"
              filter="finishFlg"
              clearable
              multiple
              collapse-tags
              placeholder="選択されていません"
            />
          </vab-col>
          <vab-col :lg="8" :xl="8" :md="12">
            <vab-select
              label="不具合有無"
              prop="defectCustomList"
              filter="existFlag2"
              clearable
              multiple
              collapse-tags
              placeholder="選択されていません"
            />
          </vab-col>
        </vab-collapse>
      </vab-row>
    </vab-query-form>
    <vab-form ref="form" :model="form" :rules="rules">
      <el-row>
        <el-col>
          <vab-table
            ref="table"
            class="vab_table vab_report_table"
            api-url="/api/workingPlanAndResult/query-list-kr"
            :columns="columns"
            :nav-buttons="navButtons"
            :enable-init="reloadPage"
            :query-params="{
              ...setQueryParams(queryForm),
              sidx: 'workNo,workingPlanAndResultId',
              sort: 'desc,desc',
            }"
            :init-params="{
              ...setQueryParams(queryForm),
              sidx: 'workNo,workingPlanAndResultId',
              sort: 'desc,desc',
            }"
            primary-key="workingPlanAndResultId"
            :row-class-name="
              ({ row, rowIndex }) =>
                rowClassName(row, rowIndex, 'workNo', selectRows)
            "
            @select="setSelectRows"
            @select-all="handleSelectAll"
          />
        </el-col>
      </el-row>
    </vab-form>
  </div>
</template>

<script lang="jsx">
  import { getFoundSelfData } from '@/api/rc/PWR02G04'
  // import { exportTemplateZip } from '@/api/rc/PWR02G05'
  import reload from '@/utils/reload'
  import format from 'string-format'
  import { upload } from '@/api/file'

  export default {
    name: 'PWR02G05',
    extends: reload,
    data() {
      return {
        downloadDisabled: true,
        workSpecCdListDisabled: true,
        workSpecCdList: [],
        fileList: [],
        form: {},
        selectRows: [],
        rules: {
          workYm: [
            {
              validator: this.workYmValidate,
              trigger: 'blur',
            },
          ],
        },
        queryForm: {
          itemDetailCdList: [],
          supplierCdList: null,
          preReportStatusList: [],
          officalReportStatusList: [],
          workYm: null,
        },
        navButtons: [
          {
            name: ' 報告書雛形ダウンロード',
            type: 'primary',
            svg: 'down',
            plain: true,
            hidden: false,
            disabled: true,
            weight: '500',
            click: () => {
              this.handleReportDownload()
            },
          },
          {
            type: 'slot',
            hidden: false,
            render: () => {
              return (
                <div class="flex_start flex_center_align hollow_box pdlr8">
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    action=""
                    multiple
                    show-file-list={false}
                    auto-upload={false}
                    {...{
                      props: {
                        'on-change': (file, fileList) => {
                          if (this.checkEfile(fileList)) return
                          this.fileList = fileList
                        },
                      },
                    }}
                  >
                    <svg-icon class="className" icon-class="upload" />
                    <span>報告書一括アップロード</span>
                  </el-upload>
                </div>
              )
            },
          },
        ],
        columns: [
          {
            width: 44,
            type: 'selection',
            fixed: 'left',
          },
          {
            label: '報告書No',
            'min-width': 140,
            prop: 'workNo',
          },
          {
            label: '建物',
            'min-width': 240,
            prop: 'buildingCdMbuildgpModel.blgsnmkj',
          },
          {
            label: '商品明細',
            'min-width': 240,
            prop: 'itemCdMitmdtlpModel.itmdtlnm',
          },
          {
            label: '点検仕様',
            'min-width': 120,
            prop: 'workSpecName',
          },
          {
            label: '作業完了状況',
            'min-width': 140,
            prop: 'reportBaseRcModel.workFinishClass',
            sortable: false,
            formatter: (row, column, cellValue) => {
              if (row.reportBaseRcModel) {
                if (!cellValue) {
                  return this.$divisions.finishFlgEnum.enum_blank.text
                }
                return this.getEnumText(
                  cellValue,
                  this.$divisions.finishFlgEnum
                )
              } else {
                return this.$divisions.finishFlgEnum.enum_blank.text
              }
            },
          },
          {
            label: '速報版報告書状況',
            'min-width': 160,
            prop: 'reportBaseRcModel.preReportStatus',
            sortable: false,
            formatter: (row, column, cellValue) => {
              if (row?.reportBaseRcModel?.reportFormat) {
                if (
                  row?.reportBaseRcModel?.reportFormat == '2' ||
                  row?.reportBaseRcModel?.reportFormat == '3'
                ) {
                  return '-'
                }
                if (row.reportBaseRcModel) {
                  if (cellValue) {
                    return this.getEnumText(
                      cellValue,
                      this.$divisions.reportStatusEnum
                    )
                  } else {
                    return this.$divisions.reportStatusEnum.enum_00.text
                  }
                }
              } else {
                return this.$divisions.reportStatusEnum.enum_00.text
              }
            },
          },
          {
            label: '正式版報告書状況',
            'min-width': 160,
            prop: 'reportBaseRcModel.officalReportStatus',
            sortable: false,
            formatter: (row, column, cellValue) => {
              if (row.reportBaseRcModel) {
                if (row?.reportBaseRcModel?.reportFormat == '3') {
                  return '-'
                }
                if (cellValue) {
                  return this.getEnumText(
                    cellValue,
                    this.$divisions.reportStatusEnum
                  )
                } else {
                  return this.$divisions.reportStatusEnum.enum_00.text
                }
              } else {
                return this.$divisions.reportStatusEnum.enum_00.text
              }
            },
          },
          {
            label: '不具合有無',
            'min-width': 120,
            prop: 'reportBaseRcModel.defectFlag',
            sortable: false,
            formatter: (row, column, cellValue) => {
              if (row?.reportBaseRcModel) {
                if (row?.reportBaseRcModel?.reportFormat == '3') {
                  return '-'
                }
                let list = [
                  this.$divisions.defectFlagEnum.enum_1.value,
                  this.$divisions.defectFlagEnum.enum_2.value,
                  this.$divisions.defectFlagEnum.enum_3.value,
                ]
                return list.includes(cellValue)
                  ? this.$divisions.existFlag2Enum.enum_1.text
                  : this.$divisions.existFlag2Enum.enum_blank.text
              } else {
                return this.$divisions.existFlag2Enum.enum_blank.text
              }
            },
          },
          {
            label: '速報版提出期限日',
            'min-width': 160,
            sortable: false,
            prop: 'reportBaseRcModel.preReportSubmintDeadline',
            formatter: (row, column, cellValue) => {
              if (
                row?.reportBaseRcModel &&
                row?.reportBaseRcModel?.reportFormat == '3'
              ) {
                return '-'
              } else {
                return cellValue
              }
            },
          },
          {
            label: '正式版提出期限日',
            'min-width': 160,
            sortable: false,
            prop: 'reportBaseRcModel.officalReportSubmintDeadline',
            formatter: (row, column, cellValue) => {
              if (
                row?.reportBaseRcModel &&
                row?.reportBaseRcModel?.reportFormat == '3'
              ) {
                return '-'
              } else {
                return cellValue
              }
            },
          },
          {
            // 按钮
            type: 'actions',
            label: '操作',
            fixed: 'right',
            'min-width': 120,
            disableCheck: true,
            info: '詳細',
            svg: 'right_line',
            show: (row) => {
              return !this.isEqualCodeEnum(
                row?.reportBaseRcModel?.reportFormat,
                this.$divisions.reportFormatEnum.enum_3
              )
            },
            click: (row) => {
              this.$routerPush({
                name: 'PWR02G06',
                query: {
                  workNo: row.workNo,
                  reportId: row.reportBaseRcModel?.reportId,
                  itemDetailCd: row.itemDetailCd,
                  reportFormat: row.reportBaseRcModel?.reportFormat,
                  sectionCd: row.sectionCd,
                  workSpecCd: row?.workSpecCd,
                },
              })
            },
          },
        ],
      }
    },
    watch: {
      async 'queryForm.itemDetailCdList'(list) {
        if (this.$baseLodash.isEmpty(list)) {
          this.workSpecCdListDisabled = true
        } else {
          this.workSpecCdListDisabled = false
          // 点検仕様
          this.workSpecCdList = await getFoundSelfData({
            itmdtlcd: list,
          })
        }
      },
      fileList(val) {
        setTimeout(() => {
          if (val.length) {
            this.$refs.upload.clearFiles()
            this.uploadAll()
          }
        }, 300)
      },
    },
    mounted() {
      this.queryForm.workYm = this.$route.query.workYm
        ? this.$route.query.workYm
        : this.$dayjs().format('YYYYMM')
      // 速報版報告書状況
      this.getPreReportStatusList()
      // 正式版報告書状況
      this.getOfficalReportStatusList()
    },
    methods: {
      // 商品明細
      clearOtherData() {
        this.$refs.workSpecRef.setValue([])
        this.queryForm.workSpecCdList = []
      },
      // 報告書一括アップロード
      async uploadAll() {
        if (!this.checkfileSize(this.fileList)) {
          return
        }
        const loadingInstance = this.$baseColorfullLoading()
        try {
          let formData = new FormData()
          this.fileList.forEach((file) => {
            formData.append('files', file.raw) //ファイル
          })
          const res = await upload(`/api/reportFileRc/bunchUpload`, formData)
          loadingInstance.close()
          if (res) {
            this.$baseNotify(
              this.$t(`validateMessage.${this.$messageCode.I00000429.name}`)
            )
            this.fetchData()
          }
        } finally {
          loadingInstance.close()
        }
      },
      // 点検年月チェック
      workYmValidate(rule, value, callback) {
        if (this.$baseLodash.isEmpty(this.queryForm.workYm)) {
          return callback(
            new Error(
              format(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`),
                '作業年月'
              )
            )
          )
        }
        callback()
      },
      // 全て選択
      handleSelectAll(val) {
        this.setSelectRows(val)
      },
      setSelectRows(val) {
        this.selectRows = val
        if (val.length > 0) {
          this.navButtons[0].disabled = false
        } else {
          this.navButtons[0].disabled = true
        }
      },
      successFile() {
        this.msgSuccess(
          this.$t(`validateMessage.${this.$messageCode.I00000429.name}`)
        )
      },
      // 報告書雛形ダウンロード
      async handleReportDownload() {
        // if (this.selectRows.length == 0) return
        // const loading = this.$baseColorfullLoading()
        // try {
        //   const res = await exportTemplateZip(this.selectRows)
        //   if (res) {
        //     this.downloadBlob(res.data, res.filename)
        //     this.msgSuccess(
        //       this.$t(`validateMessage.${this.$messageCode.I00000430.name}`)
        //     )
        //   }
        // } finally {
        //   loading.close()
        // }
        this.downloadCommon.zip(
          '/api/workingPlanAndResult/exportTemplateZip',
          this.selectRows
        )
      },
      // 検索ボタン
      fetchData() {
        this.selectRows = []
        this.$refs.table.clearSelection()
        this.$refs.table.fetchData()
        this.navButtons[0].disabled = true
      },
      cancelSet() {
        this.selectRows = []
        this.$refs.table.clearSelection()
        this.navButtons[0].disabled = true
      },
      reset() {
        this.file = null
        this.fileList = null
        this.$refs.upload.clearFiles()
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
<style lang="scss" scoped>
  .workresultlistdiv1 {
    .flex_space {
      justify-content: flex-end;
    }

    .vab-theme-darkBlue-black .el-button--primary {
      background: #ffffff !important;
      border: 1px solid #0060c2 !important;
      border-radius: 3px !important;
      color: #0060c2 !important;
    }

    .firtcoldiv {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .datediv {
        display: flex;
        align-items: center;
      }
    }
  }
  .vab_table ::v-deep .hollow_box {
    margin-right: 8px;
  }

  $fontColor: var(--font-color, #0060c2);
  $hoverColor: var(--hover-color, #0071ee);
  $borderColor: var(--border-color, #0060c2);
  .hollow_box {
    padding: 0 10px;
    height: 28px;
    border: 1px solid $borderColor;
    border-radius: 3px;
    color: $fontColor;
    cursor: pointer;
    background-color: #fff;
    &:hover {
      @if $hoverColor {
        border-color: $hoverColor;
        color: $hoverColor;
      }
    }
  }
  .pl0 {
    padding-left: 0 !important;
  }
</style>
